import { render, staticRenderFns } from "./editCorrespondenceModal.vue?vue&type=template&id=7378cf4e&"
import script from "./editCorrespondenceModal.vue?vue&type=script&lang=js&"
export * from "./editCorrespondenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports